export enum XmResult {    
    Acceptable = 1,
    Unacceptable = 2,
    MostlyAcceptable = 3
}